module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$auth.isAuditor()) ? _c('records', {
    attrs: {
      "paginating": true,
      "filtering": true,
      "exportable": true,
      "bulk": true,
      "actions": true
    }
  }) : _c('recording-requests')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46efcf13","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Recordings.vue
// module id = 1072
// module chunks = 1